import React from "react";
import LawFirmBondsPage from "./components/LawFirmBondsPage";
import { LAW_FIRM_BONDS_MODES } from "./helpers/lawFirmBondsPageConfig";

const LawFirmCancelBonds = () => (
  <LawFirmBondsPage mode={LAW_FIRM_BONDS_MODES.CANCEL} />
);

export default LawFirmCancelBonds;
